<div>

    <button mat-button [matMenuTriggerFor]="storeMenu" style="margin-left: 10px;">
           <span i18n="@@storeName">  <img width="20" src="{{this.selected_store?.icon}}" /> Store</span> <span>- {{selected_store?.name}}</span>
    </button>

    <mat-menu #storeMenu="matMenu" >
        <span (click)="storeChanged($event,store)" style="color: #0c0c0c;" *ngFor="let store of this.stores" mat-menu-item>
            {{store?.name}}
        </span>
<!--    <a href="/en-US/web/home" (click)="changeToEnglish() " mat-menu-item>English</a>-->
<!--    <a href="/ar/web/home" (click)="changeToArabic()" mat-menu-item>العربية</a>-->
    </mat-menu>


</div>
